import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import Model from './ModelRulemrm.mjs'

export const FormItemRmName = props => (
    <FormItemBizProp
        Model={Model}
        prop="rmName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export const FormItemRmNo = props => (
    <FormItemBizProp
        Model={Model}
        prop="rmNo"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseRulemrm(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemRmNo />
            <FormItemRmName />
        </FormChooseDesign>
    )
}
